import LegacyInterceptor from '../LegacyInterceptor'

const api = new LegacyInterceptor()

export default {
  abasExibir(){
    return api.get('users/current/relatorios/abas-exibir')
  },

  getDetalheRelatorioFontePagadora({ fontePagadora, operadoraId, initialDate, finalDate, prestadorId, profissionalExecutanteId }) {
    let url = `/medico/producao/aprovada/detalhes/fonte-pagadora/${fontePagadora}/operadora/${operadoraId}?dataRealizacaoInicial=${initialDate}&dataRealizacaoFinal=${finalDate}`

    if (prestadorId) url += `&prestadorId=${prestadorId}`
    if (profissionalExecutanteId) url += `&profissionalExecutanteId=${profissionalExecutanteId}`

    return api.get(url)
  },

  getDetalheRelatorioOperadora({ operadoraId, localExecucaoId, initialDate, finalDate, prestadorId, profissionalExecutanteId }) {
    let url = `/medico/producao/aprovada/detalhes/operadora/${operadoraId}/local-execucao/${localExecucaoId}?dataRealizacaoInicial=${initialDate}&dataRealizacaoFinal=${finalDate}`

    if (prestadorId) url += `&prestadorId=${prestadorId}`
    if (profissionalExecutanteId) url += `&profissionalExecutanteId=${profissionalExecutanteId}`

    return api.get(url)
  },

  listarPorFontePagadora(medicoId, dataEpochInicial, dataEpochFinal) {
    return api.get(`medico/${medicoId}/producao/aprovada/relatorio/fonte-pagadora/${encodeURI(dataEpochInicial)}/${encodeURI(dataEpochFinal)}`)
  },

  listarDetalhePorFontePagadora(idFontePagadora, idOperadora, dataEpochInicial, dataEpochFinal) {
    return api.get(`medico/producao/aprovada/fonte-pagadora/${encodeURI(idFontePagadora)}/operadora/${encodeURI(idOperadora)}/${encodeURI(dataEpochInicial)}/${encodeURI(dataEpochFinal)}`)
  },

  listarPorOperadora(medicoId, dataEpochInicial, dataEpochFinal) {
    return api.get(`medico/${medicoId}/producao/aprovada/relatorio/operadora/${encodeURI(dataEpochInicial)}/${encodeURI(dataEpochFinal)}`)
  },

  listarDetalhePorOperadora(idOperadora, idLocalExecucao, dataEpochInicial, dataEpochFinal) {
    return api.get(`medico/producao/aprovada/operadora/${encodeURI(idOperadora)}/local-execucao/${encodeURI(idLocalExecucao)}/${encodeURI(dataEpochInicial)}/${encodeURI(dataEpochFinal)}`)
  },

  getRelatorio({ initialDate, finalDate, relatorioType, prestadorId, profissionalExecutanteId }) {
    let url = `/medico/producao/aprovada/relatorio/${relatorioType}?dataRealizacaoInicial=${initialDate}&dataRealizacaoFinal=${finalDate}`

    if (prestadorId) url += `&prestadorId=${prestadorId}`
    if (profissionalExecutanteId) url += `&profissionalExecutanteId=${profissionalExecutanteId}`

    return api.get(url)
  },
}
